import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    contestCreationID: "",
    noOfQuestions: "",
    examStartDateTime: "",
    examEndDateTime: "",
    duration: "",
    // subjectCode: "",
    sub1Duration: "",
    sub2Duration: "",
    sub3Duration: "",
    subject1Name: "",
    subject2Name: "",
    subject3Name: "",
    weightage: "",
    assessmentType: "",
    // assessmentName: "",
    subject1Question: "",
    subject2Question: "",
    subject3Question: "",
    subject1QuestionWeightage: "",
    subject2QuestionWeightage: "",
    subject3QuestionWeightage: "",
}

const AssessmentDetailSlice = createSlice({
    name: "AssessmentDetailSlice",
    initialState,

    reducers: {
        AssessmentDetailsData(state, action) {
            return {
                contestCreationID: action.payload.contestCreationID,
                noOfQuestions: action.payload.noOfQuestions,
                examStartDateTime: action.payload.examStartDateTime,
                examEndDateTime: action.payload.examEndDateTime,
                duration: action.payload.duration,
                // subjectCode: action.payload.,
                sub1Duration: action.payload.sub1Duration,
                sub2Duration: action.payload.sub2Duration,
                sub3Duration: action.payload.sub3Duration,
                subject1Name: action.payload.subject1Name,
                subject2Name: action.payload.subject2Name,
                subject3Name: action.payload.subject3Name,
                weightage: action.payload.weightage,
                assessmentType: action.payload.assessmentType,
                // assessmentName: action.payload.,
                subject1Question: action.payload.subject1Question,
                subject2Question: action.payload.subject2Question,
                subject3Question: action.payload.subject3Question,
                subject1QuestionWeightage: action.payload.subject1QuestionWeightage,
                subject2QuestionWeightage: action.payload.subject2QuestionWeightage,
                subject3QuestionWeightage: action.payload.subject3QuestionWeightage,

            };
        }
    }
})
export const { AssessmentDetailsData } = AssessmentDetailSlice.actions;
export default AssessmentDetailSlice.reducer;